export const JOB_NAME = {
  TRANSLATION_SCRIPT: "translation_script",
  TEXT_TO_SPEECH_SCRIPT: "text_to_speech_script",
  TRANSLATION_SCRIPT_NEW: "translation_script_new",
  CSV_EXPORT: "csv_export",
  CSV_EXPORT_TASK: "csv_export_task",
  ALGO_CREATION: "algo_creation",
  CHECK_WORD_IN_SENTENCE: "check_word_in_sentence",
  ADITIONAL_PAGE_EXPORT: "aditional_page_export",
  TRANSLATION_CORE_TO_CORE: "translation_core_to_core",
  DUPLICATE_LESSONS: "duplicate_lessons",
  IMPORT_DATABASE: "import_database",
  MARK_WORDS_AS_USER: "mark_words_as_user",
  CLEAR_CSV_IMPORTED_DATA: "clear_csv_imported_data",
};

export const JOB_STATUS = {
  TO_PROCESS: "to_process",
  PENDING: "pending",
  END: "end",
};
